import { useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeaders() {
  const token = localStorage.getItem('auth_token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
}

export function useConversationList() {
  const [conversations, setConversations] = useState([]);

  const loadConversations = async () => {
    try {
      const response = await fetch(`${API}/conversations`, {
        headers: authHeaders(),
      });
      if (response.status === 401) {
        localStorage.removeItem('auth_token');
        window.location.reload();
        return;
      }
      const data = await response.json();
      setConversations(data);
    } catch (e) {
      console.error('Error loading conversations:', e);
    }
  };

  const createConversation = async () => {
    try {
      const response = await fetch(`${API}/conversations`, {
        method: 'POST',
        headers: authHeaders(),
      });
      if (response.status === 401) {
        localStorage.removeItem('auth_token');
        window.location.reload();
        return null;
      }
      const newConv = await response.json();
      setConversations(prev => [newConv, ...prev]);
      return newConv;
    } catch (e) {
      console.error('Error creating conversation:', e);
      return null;
    }
  };

  const deleteConversation = async (conversationId) => {
    try {
      await fetch(`${API}/conversations/${conversationId}`, {
        method: 'DELETE',
        headers: authHeaders(),
      });
      setConversations(prev => prev.filter(c => c.id !== conversationId));
    } catch (e) {
      console.error('Error deleting conversation:', e);
    }
  };

  return { conversations, loadConversations, createConversation, deleteConversation };
}
